const messages = {
  AIDOO : {
    title: 'Aidoo',
    desc: 'Device for the management and integration of an AC unit. Options: <br/> · Wi-Fi <br/> · KNX',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6xxxxxx.png',
    articles: {
      AIDOO_WIFI: {
        title: 'Aidoo Wi-Fi Controller',
        desc:  'Device to operate the A/C indoor unit; control through the Airzone Aidoo App, Wi-Fi connection and Modbus integration',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6WSCxxx.png',
        descResult: 'Control your AC settings from anywhere in the world using the <b>Airzone Aidoo app</b> (available for <a href="https://play.google.com/store/apps/details?id=es.airzone.aidoo" target="_blank" style="color:#007f9b">Android</a> and <a href="https://apps.apple.com/app/airzone-aidoo/id1468065088" target="_blank" style="color:#007f9b">iOS</a>). Compatible with:',
        logos: [
          'https://doc.airzone.es/Resources/Images/IMG_logo-Google-Assistant.png',
          'https://doc.airzone.es/Resources/Images/IMG_logo-Alexa.png',
        ],
      },
      AIDOO_KNX: {
        title: 'Aidoo KNX Controller',
        desc: 'Device to operate the A/C indoor unit; KNX TP-1 control and 3 configurable digital inputs',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZAI6KNXxxx.png',
        descResult: 'Compatible with the ETS5 software, you can easily configure Aidoo KNX and include it in your project. Download our <a href="https://doc.airzone.es/producto/Gama_AZ6/Airzone/Aidoo/BBDD_AZAI6KNX.zip" style="color:#007f9b">database</a>.',
      }
    },
    include: {
      protocolo: '%{protocolo} %{article}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a> with:',
      accesrories: [
        'Connection cable to unidad interior. the indoor unit.',
        'Screws and doublesided adhesive tape for the assembly.',
      ],
    }
  },
  ZONIFIED : {
    title: 'Gateway for zoned system',
    desc: 'Gateway to control ducted zone indoor unit',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
    articles: {
      COMMUNICATION_GATEWAY: {
        title: 'Comunication Gateway',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZX6GTCxxx.png',
        descResult: '',
      }
    },
    include: {
      pack1: 'Airzone - %{protocolo} communication gateway: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Airzone - %{protocolo} controller 3.0 gateway: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  MONOZONE : {
    title: 'Zone module for individual equipment',
    desc: 'Cable / radio zone module to control an individual device',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
    articles: {
      WIRED_ZONE_MODULE: {
        title: 'Airzone wired zone module',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxC.png',
        descResult: '',
        conection: 'Wired'
      },
      WIRELESS_ZONE_MODULE: {
        title: 'Airzone wireless zone module',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZDI6ZMOxxxR.png',
        descResult: '',
        conection: 'Wireless'
      }
    },
    include: {
      pack: '%{protocolo} - %{name}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
      pack2: 'Airzone %{protocolo} zone module kit %{conection}: <a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>',
    }
  },
  UNO_SYSTEM : {
    title: 'Pack UNO',
    desc: 'Central + wired / wireless thermostat for to control a single individual device',
    img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PxxxBFCB.png',
    articles: {
      UNO_BLUEFACE_WHITE: {
        title: 'Pack Airzone UNO White Blueface',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCB.png',
        descResult: '',
        type: 'Blueface',
        color: 'White',
        conection: 'Wired'
      },
      UNO_BLUEFACE_BLACK: {
        title: 'Pack Airzone UNO Black Blueface',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxBFCN.png',
        descResult: '',
        type: 'Blueface',
        color: 'Black',
        conection: 'Wired'
      },
      UNO_THINK_WIRELESS_WHITE: {
        title: 'Pack Airzone UNO White Think Wireless',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRB.png',
        descResult: '',
        type: 'Think',
        color: 'White',
        conection: 'Wireless'
      },
      UNO_THINK_WIRELESS_BLACK: {
        title: 'Pack Airzone UNO Black Think Wireless',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHRN.png',
        descResult: '',
        type: 'Think',
        color: 'Black',
        conection: 'Wireless'
      },
      UNO_THINK_WIRED_WHITE: {
        title: 'Pack Airzone UNO White Think Wired',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCB.png',
        descResult: '',
        type: 'Think',
        color: 'White',
        conection: 'Wired'
      },
      UNO_THINK_WIRED_BLACK: {
        title: 'Pack Airzone UNO Black Think Wired',
        desc: '',
        img: 'https://doc.airzone.es/Resources/Images/IMG_AZUN6PQxxxTHCN.png',
        descResult: '',
        type: 'Think',
        color: 'Black',
        conection: 'Wired'
      }
    },
    include: {
      pack: '%{protocolo} Airzone Pack UNO %{type} thermostat (<a href=%{url} target="_blank" style="color:#007f9b">%{product}</a>) con :',
      list1: '%{type} %{conection} Airzone UNO main control board with integrated %{protocolo} communication gateway..',
      list2: 'Airzone %{type} %{conection} thermostat %{color}.',
      list3: 'Airzone bus wired 10 m.',
      list4: 'Battery button CR2450.',
    }
  },
  CompatibilityList: 'Compatibility list',
  SelectBrand: 'Select your brand',
  SelectCompatibilityAirzone: 'Select your Airzone device',
  SelectAtricleAirzone: 'Select the Airzone article',
  SelectIndoorUnitModel: 'Select your indoor unit model',
  ResultUnid: 'For %{unid} unit (%{manufacturer})',
  ResultYourRefer: 'Your Airzone reference is:',
  NamePdfFile: 'Airzone-reference-compatibility',
  SelectInclude: 'Your selection includes:',
  ZoneSystem: 'Zones control system',
  MonozoneController: 'Single zone controllers',
  List: 'To list',
  protocolo: {
    DA0: 'Daikin Residential',
    DA1: 'Daikin Sky Air / VRV',
    DA2: 'Daikin Altherma 3',
    FUJ: 'Fujitsu 3 wires',
    FU2: 'Fujitsu UART',
    GRE: 'Gree U-Match R410A',
    GR1: 'Gree U-Match R32',
    HAI: 'Haier',
    HIT: 'Hitachi RPI',
    HI2: 'Hitachi RAD',
    LGE: 'LG',
    MD1: 'Midea V5 protocol',
    MD2: 'Midea V6 protocol',
    MEL: 'Mitsubishi Electric',
    MHI: 'Mitsubishi Heavy',
    PA0: 'Panasonic RAC Domestic',
    PAN: 'Panasonic',
    TOS: 'Toshiba',
    SAM: 'Samsung',
    SA2: 'Samsung Nasa',
    HS1: 'Hisense',
    BAX: 'Baxi',
    BA1: 'Baxi R32',
    F3V: 'Fancoil 3 velocidades',
    FAN: 'Fancoil',
    IFR: 'IR',
    F10: 'Fancoil 0-10V',
    HI3: 'Hitachi Primairy',
    ME2: 'Mitsubishi Electric Ecodan',
  }
};
export default messages;
